import { useContext } from "react";
import { GameContext, GameContextType } from "../../data/gameState";
import { nextVisibility, Visibility } from "../../types/Visibility";
import { getToken } from "../../util";
import { isStorytellerToken } from "../../data/teamData";

/**
 * Edit the token's visibility -- cycle between being assigned, a demon bluff, or hidden for administrative reasons. 
 * @returns 
 */
export default function VisibilityButton() {
    const {gameState, setGameState, appState, roles} = useContext(GameContext) as GameContextType;
    const token = getToken(appState.activeTokenUid, gameState)!;
    const index = gameState.playerTokens.indexOf(token);
    
    let visibilityUrl: string;
    switch (token.visibility) {
        case Visibility.Assigned:
            visibilityUrl = "url('assets/buttons/bluff.png')";
            break;
        case Visibility.Bluff:
            visibilityUrl = "url('assets/buttons/hideToken.png')";
            break;
        case Visibility.Hidden:
            visibilityUrl = "url('assets/buttons/showToken.png')";
            break;
    }

    if (isStorytellerToken(token, roles)) return <></>;

    function cycleVisibility() {        
        setGameState(oldState => {
            return {
                ...oldState,
                playerTokens: [
                    ...oldState.playerTokens.slice(0, index),
                    {
                        ...oldState.playerTokens[index],
                        visibility: nextVisibility(token.visibility)
                    },
                    ...oldState.playerTokens.slice(index+1)
                ]
            };
        })
    }
    
    return (
        <div 
            onClick={cycleVisibility}
            role="button"
            className="InfoPowers__option" 
            style={{backgroundColor: "#00639C", backgroundImage: visibilityUrl}}
        ></div>
    )
}